<template>
    <div>
        <Loading :active="loading" :is-full-page="true" />
        <div align="center" justify="center" class="pa-3">
            <v-card align="left" justify="left" class="mb-3">
                <v-card-text class="pa-3 font-weight-light white black--text">
                    <v-icon class="primary--text lighten-2 pa-2">
                        mdi-account-group
                    </v-icon>
                    Administração > Gerenciamento de Login Social
                </v-card-text>
            </v-card>

            <v-card @keyup.native.enter="aplicarFiltros" class="pa-3 mb-4">
                <v-row class="pa-5 d-flex align-center">
                    <v-col
                        cols="12"
                        sm="6"
                        md="4"
                        lg="3"
                        class="d-flex flex-row pa-0 pb-3 responsive"
                    >
                        <v-text-field
                            v-model="filtroGlobal"
                            label="Buscar por nome, email"
                            outlined
                            dense
                            hide-details
                            :disabled="loading"
                            clearable
                            prepend-inner-icon="mdi-magnify"
                            data-cy="filtroGlobal"
                        ></v-text-field>
                    </v-col>
                    <v-col
                        cols="12"
                        sm="6"
                        md="3"
                        lg="2"
                        class="d-flex flex-row pa-0 pb-3"
                    >
                        <v-select
                            v-model="filtroPerfil"
                            :items="perfilOptions"
                            label="Filtrar por Perfil"
                            outlined
                            dense
                            hide-details
                            :disabled="loading"
                            clearable
                            data-cy="filtroPerfil"
                        ></v-select>
                    </v-col>

                    <v-col
                        cols="12"
                        sm="12"
                        md="5"
                        lg="7"
                        class="d-flex justify-end justify-sm-end justify-md-end align-center pa-0"
                    >
                        <div class="d-flex flex-wrap justify-end">
                            <v-btn
                                color="primary"
                                class="mr-2 mb-2 mb-lg-"
                                :disabled="loading"
                                @click="aplicarFiltros"
                                data-cy="btnFiltrar"
                            >
                                <v-icon left>mdi-magnify</v-icon>
                                <span class="d-none d-sm-inline">Filtrar</span>
                            </v-btn>
                            <v-btn
                                outlined
                                color="secondary"
                                class="mr-2 mb-2 mb-sm-0"
                                :disabled="loading"
                                @click="limparFiltros"
                                data-cy="btnLimpar"
                            >
                                <v-icon left>mdi-filter-remove</v-icon>
                                <span class="d-none d-sm-inline">Limpar</span>
                            </v-btn>
                            <v-btn
                                color="success"
                                :disabled="loading"
                                @click="abrirModalNovo"
                                data-cy="btnNovo"
                                class="mb-2 mb-sm-0"
                            >
                                <v-icon left>mdi-plus</v-icon>
                                <span class="d-none d-sm-inline">NOVO</span>
                                <span class="d-inline d-sm-none"
                                    >Login Social</span
                                >
                            </v-btn>
                        </div>
                    </v-col>
                </v-row>
            </v-card>

            <v-card class="pa-3">
                <v-data-table
                    :headers="headers"
                    :items="loginsSociais"
                    :loading="loading"
                    :footer-props="{
                        itemsPerPageOptions: [10, 20, 50],
                        itemsPerPageText: 'Itens por página:'
                    }"
                    item-key="id"
                    :item-class="getRowClass"
                    class="elevation-1"
                    :server-items-length="totalItems"
                    :page.sync="currentPage"
                    :items-per-page.sync="itemsPerPage"
                    @update:page="carregarDados"
                    @update:items-per-page="carregarDados"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    @update:sort-by="carregarDados"
                    @update:sort-desc="carregarDados"
                >
                    <template v-slot:[`item.perfil`]="{ item }">
                        <v-chip
                            :color="getPerfilColor(item.perfil)"
                            text-color="white"
                            small
                            class="perfil-chip"
                        >
                            {{ item.perfil }}
                        </v-chip>
                    </template>

                    <template v-slot:[`item.apresentantes`]="{ item }">
                        <div class="d-flex align-center">
                            <span>{{
                                truncarApresentantes(item.apresentantes)
                            }}</span>
                            <v-tooltip top v-if="item.apresentantes.length > 3">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                        v-bind="attrs"
                                        v-on="on"
                                        small
                                        color="primary"
                                        class="ml-1"
                                    >
                                        mdi-dots-horizontal
                                    </v-icon>
                                </template>
                                <span>{{
                                    item.apresentantes
                                        .map(ap => ap.cd_apresentante)
                                        .join(', ')
                                }}</span>
                            </v-tooltip>
                        </div>
                    </template>

                    <template v-slot:[`item.acoes`]="{ item }">
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    v-bind="attrs"
                                    v-on="on"
                                    icon
                                    small
                                    color="info"
                                    @click="abrirModalEdicao(item)"
                                    data-cy="btnDetalhes"
                                >
                                    <v-icon>mdi-eye</v-icon>
                                </v-btn>
                            </template>
                            <span>Detalhes</span>
                        </v-tooltip>
                    </template>
                </v-data-table>
            </v-card>
        </div>

        <ModalLoginSocial
            v-if="modalAtivo"
            :showModal="modalAtivo"
            :loginSocial="loginSocialSelecionado"
            :modoEdicao="modoEdicao"
            :apresentantesDisponiveis="apresentantesDisponiveis"
            @fecharModal="fecharModal"
            @mostrarMensagem="mostrarMensagem"
            @atualizarLista="carregarDados"
        />

        <v-snackbar
            v-model="snackbar"
            :color="snackbarColor"
            timeout="5000"
            top
            right
        >
            {{ snackbarMessage }}
            <template v-slot:action="{ attrs }">
                <v-btn text v-bind="attrs" @click="snackbar = false">
                    Fechar
                </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script>
import LoginSocialService from '@/services/LoginSocialService';
import ModalLoginSocial from '@/modals/ModalLoginSocial.vue';
import Loading from 'vue-loading-overlay';

export default {
    name: 'GerenciamentoLoginSocial',
    components: {
        ModalLoginSocial,
        Loading
    },
    data() {
        return {
            loading: false,
            loginsSociais: [],
            apresentantesDisponiveis: [],
            filtroGlobal: '',
            filtroPerfil: '',
            perfilOptions: [
                { text: 'Admin', value: 'Admin' },
                { text: 'Basic', value: 'Basic' }
            ],
            modalAtivo: false,
            loginSocialSelecionado: null,
            modoEdicao: false,
            snackbar: false,
            snackbarMessage: '',
            snackbarColor: 'success',
            currentPage: 1,
            itemsPerPage: 10,
            totalItems: 0,
            headers: [
                { text: 'ID', value: 'id', sortable: true },
                { text: 'Nome', value: 'nome', sortable: true },
                { text: 'Email', value: 'email', sortable: true },
                { text: 'Perfil', value: 'perfil', sortable: true },
                {
                    text: 'Apresentantes',
                    value: 'apresentantes',
                    sortable: false,
                    width: '200px'
                },
                {
                    text: 'Ações',
                    value: 'acoes',
                    sortable: false,
                    width: '100px'
                }
            ],
            sortBy: '',
            sortDesc: false
        };
    },
    async mounted() {
        await this.inicializar();
    },
    methods: {
        async inicializar() {
            this.loading = true;
            try {
                await Promise.all([
                    this.carregarApresentantes(),
                    this.carregarDados()
                ]);
            } catch (error) {
                const mensagemErro =
                    error.response?.data?.message ||
                    'Erro ao carregar dados iniciais';
                this.mostrarMensagem(mensagemErro, 'error');
                console.error('Erro na inicialização:', error);
            } finally {
                this.loading = false;
            }
        },

        async carregarApresentantes() {
            try {
                const service = new LoginSocialService(this.$http, this.$store);
                const response = await service.listarApresentantes();

                let apresentantesRaw = [];
                if (response.data) {
                    apresentantesRaw = response.data;
                } else if (response.results) {
                    apresentantesRaw = response.results;
                } else if (Array.isArray(response)) {
                    apresentantesRaw = response;
                } else {
                    apresentantesRaw = [];
                }

                this.apresentantesDisponiveis = apresentantesRaw.map(
                    apresentante => ({
                        sigla: apresentante.cd_apresentante,
                        nome:
                            apresentante.nm_apresentante ||
                            apresentante.nome_exibicao ||
                            apresentante.nm_razao_social,
                        cd_apresentante: apresentante.cd_apresentante,
                        nm_apresentante: apresentante.nm_apresentante
                    })
                );
            } catch (error) {
                console.error('Erro ao carregar apresentantes:', error);
                const mensagemErro =
                    error.response?.data?.message ||
                    'Erro ao carregar apresentantes';
                this.mostrarMensagem(mensagemErro, 'error');
            }
        },

        async carregarDados() {
            this.loading = true;
            try {
                const service = new LoginSocialService(this.$http, this.$store);
                const params = {
                    page: this.currentPage,
                    limit: this.itemsPerPage,
                    search: this.filtroGlobal,
                    perfil: this.filtroPerfil,
                    sortBy: this.sortBy,
                    sortDesc: this.sortDesc
                };

                const response = await service.listarLoginsSociais(params);
                this.loginsSociais = response.users || [];
                this.totalItems = response.total || 0;
            } catch (error) {
                const mensagemErro =
                    error.response?.data?.message || 'Erro ao carregar dados';
                this.mostrarMensagem(mensagemErro, 'error');
                console.error('Erro ao carregar dados:', error);
            } finally {
                this.loading = false;
            }
        },

        aplicarFiltros() {
            this.currentPage = 1;
            this.carregarDados();
        },

        limparFiltros() {
            this.filtroGlobal = '';
            this.filtroPerfil = '';
            this.aplicarFiltros();
        },

        abrirModalNovo() {
            this.loginSocialSelecionado = {
                nome: '',
                email: '',
                perfil: '',
                apresentantesSelecionados: []
            };
            this.modoEdicao = false;
            this.modalAtivo = true;
        },

        abrirModalEdicao(item) {
            this.loginSocialSelecionado = { ...item };
            if (item.perfil.toLowerCase() === 'admin') {
                this.loginSocialSelecionado.perfil = 'Admin';
            } else {
                this.loginSocialSelecionado.perfil = 'Basic';
            }
            this.loginSocialSelecionado.apresentantesSelecionados = item.apresentantes.map(
                ap => ap.cd_apresentante
            );
            this.modoEdicao = true;
            this.modalAtivo = true;
        },

        fecharModal() {
            this.modalAtivo = false;
            this.loginSocialSelecionado = null;
            this.modoEdicao = false;
        },

        mostrarMensagem(mensagem, tipo = 'success') {
            this.snackbarMessage = mensagem;
            this.snackbarColor = tipo;
            this.snackbar = true;
        },

        getPerfilColor(perfil) {
            const colors = {
                admin: 'green darken-2',
                Basic: 'blue darken-2'
            };
            return colors[perfil] || 'grey';
        },

        truncarApresentantes(apresentantes) {
            if (!apresentantes || apresentantes.length === 0) {
                return 'Nenhum';
            }

            const nomes = apresentantes.map(ap => ap.cd_apresentante);

            if (nomes.length <= 3) {
                return nomes.join(', ');
            }

            return nomes.slice(0, 3).join(', ');
        },

        getRowClass(item) {
            const perfilClasses = {
                admin: 'row-admin',
                Basic: 'row-basic'
            };
            return perfilClasses[item.perfil] || '';
        }
    }
};
</script>

<style scoped>
.v-card {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.v-card--outlined {
    border: 1px solid #e0e0e0;
}

.text-body-2 {
    line-height: 1.4;
}
.responsive {
    padding-right: 10px !important;
}

@media (max-width: 600px) {
    .responsive {
        padding-right: 0 !important;
    }
}

.row-admin {
    background-color: #e3f2fd !important;
}

.row-basic {
    background-color: #fce4ec !important;
}

.admin-row {
    background-color: rgba(33, 150, 243, 0.1) !important;
}

.admin-row:hover {
    background-color: rgba(33, 150, 243, 0.2) !important;
}

.basic-row {
    background-color: rgba(76, 175, 80, 0.1) !important;
}

.basic-row:hover {
    background-color: rgba(76, 175, 80, 0.2) !important;
}

.perfil-chip {
    min-width: 120px;
    text-transform: uppercase;
    display: flex;
    justify-content: center;
    align-items: center;
    max-width: 30px;
}
</style>
